/**
 * Debug utility for conditional logging
 * Only logs in development/test environments
 */

const isDebugMode = (): boolean => {
	return process.env.REACT_APP_DEBUG === 'true';
};

export const debugLog = (message: string, ...args: any[]): void => {
	if (isDebugMode()) {
		console.log(`[DEBUG] ${message}`, ...args);
	}
};

export const debugError = (message: string, ...args: any[]): void => {
	if (isDebugMode()) {
		console.error(`[DEBUG ERROR] ${message}`, ...args);
	}
};

export const debugWarn = (message: string, ...args: any[]): void => {
	if (isDebugMode()) {
		console.warn(`[DEBUG WARN] ${message}`, ...args);
	}
};

export const debugInfo = (message: string, ...args: any[]): void => {
	if (isDebugMode()) {
		console.info(`[DEBUG INFO] ${message}`, ...args);
	}
};
